export default "__VITE_ASSET__$d4NgrM3__"